export default __webpack_public_path__ + "static/media/failure.icon.bf4bc319.svg";